import DialogPolicyPointPage from "./DialogPolicyPointContainer";

export default DialogPolicyPointPage;
